import { render, staticRenderFns } from "./BarScroll.vue?vue&type=template&id=3469683c&scoped=true&"
import script from "./BarScroll.vue?vue&type=script&lang=js&"
export * from "./BarScroll.vue?vue&type=script&lang=js&"
import style0 from "./BarScroll.vue?vue&type=style&index=0&id=3469683c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3469683c",
  null
  
)

export default component.exports